module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+aWNvbi1yZWZyZXNoPC90aXRsZT48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yMiAydjIwSDJWMnoiLz48cGF0aCBkPSJNMTggNi43MDhhOCA4IDAgMSAwIDEuMzEyIDguNTQybC0xLjgyOC0uODEzQTYuMDAxIDYuMDAxIDAgMCAxIDYgMTJhNiA2IDAgMCAxIDEwLjQ3Mi00SDE0djJoNlY0aC0ydjIuNzA4eiIgZmlsbD0iIzQ4NDg0OCIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctype/icon-start.svg
// module id = b533
// module chunks = 25